import script from "./BalVerticalSteps.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalVerticalSteps.vue?vue&type=script&lang=ts&setup=true"

import "./BalVerticalSteps.vue?vue&type=style&index=0&id=33c347ba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c347ba"]])

export default __exports__